import Modal from '../Modal/Modal'
import PopupMessage from '../PopupMessage/PopupMessage'
import FormBodyDesktop from './FormBodyDesktop'
import FormBodyMobile from './FormBodyMobile'

import { useContext, useState } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
// import { fetchAPI } from '../../helpers/api'

import useAuth from '../../hooks/useAuth'
import useMediaQuery from '../../hooks/useMediaQuery'
// import { getProfile } from '../../api/users'

const PaymentForm = () => {
    const { token } = useContext(AuthContext)
    const { getCurrentUserID, refreshToken } = useAuth()
    const [inputs, setInputs] = useState({})
    const [popup, setPopup] = useState({ message: '', type: '', shown: false })
    const isMobile = useMediaQuery('(max-width:1024px)')
    console.log(getCurrentUserID())
    console.log(token)
    const [termsAccepted, setTermsAccepted] = useState(false)

    const handleTerms = e => {
        setTermsAccepted(e.target.checked)
    }

    // useEffect(() => {
    //     const script = document.createElement('script')

    //     script.src =
    //         'https://ibanke-commerce.nbg.gr/static/checkout/checkout.min.js'

    //     document.head.appendChild(script)

    //     return () => document.head.removeChild(script)
    // }, [])

    const handleChange = e => {
        const name = e.target.name
        const value = e.target.value
        setInputs(values => ({ ...values, [name]: value }))
    }

    const submitHandler = async e => {
        e.preventDefault()

        const isFormValid = validateForm()

        if (!isFormValid) {
            return
        }

        const nbgData = await initiateCheckout()

        if (!nbgData.success) {
            setPopup(values => ({
                ...values,
                shown: true,
                message: (
                    <>
                        {nbgData.message ? (
                            <p> {nbgData.message} </p>
                        ) : (
                            <>
                                <p>Κάτι πήγε στραβά! </p>
                                <p>Παρακαλώ προσπαθήστε ξανά.</p>
                            </>
                        )}
                    </>
                ),
                type: 'error',
            }))

            return
        }

        // eslint-disable-next-line no-undef
        // Checkout.configure({
        //     session: {
        //         id: nbgData.data.session.id,
        //     },
        // })

        // eslint-disable-next-line no-undef
        // Checkout.showPaymentPage()
    }

    const validateForm = () => {
        if (!termsAccepted) {
            setPopup(values => ({
                ...values,
                shown: true,
                message: 'Πρέπει να αποδεχτείτε τους όρους χρήσης.',
                type: 'error',
            }))
            return false
        }

        const validAmount =
            inputs.amount >= 0 && typeof parseInt(inputs.amount) === 'number'

        if (!(inputs.paymentCode && inputs.description && inputs.amount)) {
            setPopup(values => ({
                ...values,
                shown: true,
                message:
                    'Η συμπλήρωση όλων των πεδίων είναι υποχρεωτική για την πληρωμή της οφειλής.',
                type: 'error',
            }))
            return false
        }

        if (!validAmount) {
            setPopup(values => ({
                ...values,
                shown: true,
                message: 'Το ποσό πληρωμής που εισάγατε δεν ειναι αποδεκτό,',
                type: 'error',
            }))
            return false
        }

        return true
    }

    const initiateCheckout = async () => {
        // const profileData = await getProfile({
        //     headers: {
        //         Authorization: `Bearer ${token.access_token}`,
        //     },
        // })
        // const profile = profileData?.profile
        // let fullName
        const extras = {}
        if (inputs.hydrometer) {
            extras.hydrometer = inputs.hydrometer
        }
        // profile
        //     ? (fullName = `${profile?.firstName} ${profile?.lastName}`)
        //     : (fullName = '-')
        try {
            // Refresh the tokens before initiating the NBG checkout
            refreshToken()
            // const checkoutBody = {
            //     payment: {
            //         description: inputs.description,
            //         paymentCode: inputs.paymentCode,
            //         address: inputs.address,
            //         extras: extras,
            //         amount: parseFloat(inputs.amount),
            //         type: inputs.paymentType,
            //         associateTitle: fullName,
            //         debts: [
            //             {
            //                 debtId: inputs.paymentCode,
            //                 totalAmount: parseFloat(inputs.amount),
            //             },
            //         ],
            //     },
            //     userId: getCurrentUserID(),
            // }
            // const res = await fetchAPI(
            //     `${process.env.REACT_APP_API_URL}/payments/initiateCheckout`,
            //     {
            //         method: 'POST',
            //         headers: {
            //             Authorization: `Bearer ${token.access_token}`,
            //             'Content-Type': 'application/json',
            //         },
            //         body: JSON.stringify(checkoutBody),
            //     }
            // )

            // eslint-disable-next-line no-undef
            // Checkout.configure({
            //     session: {
            //         id: res.data.session.id,
            //     },
            // })

            // eslint-disable-next-line no-undef
            // Checkout.showPaymentPage()

            setPopup(values => ({
                ...values,
                shown: true,
                message: (
                    <>
                        <p className="text-sm sm:text-base">
                            Η υπηρεσία ηλεκτρονικής πληρωμής δεν είναι διαθέσιμη
                            αυτή τη στιγμή. Παρακαλώ προσπαθήστε αργότερα ή
                            επιλέξτε την κατάθεση σε τραπεζικό λογαριασμό του
                            Δήμου.
                        </p>

                        <p className="mt-3 font-semibold text-base sm:text-lg">
                            Τρόποι Πληρωμής:
                        </p>

                        <ul className="list-disc ml-5 text-sm sm:text-base">
                            <li className="text-justify">
                                Σε οποιοδήποτε υποκατάστημα της Τράπεζας
                                Πειραιώς.
                            </li>
                            <li className="text-justify">
                                Μέσω Web Banking (e-banking) οποιασδήποτε
                                τράπεζας, χρησιμοποιώντας το ΙΒΑΝ.
                            </li>
                        </ul>

                        <h4 className="mt-4 mb-2 text-base font-bold sm:text-xl">
                            Στοιχεία Λογαριασμού:
                        </h4>

                        <ul className="text-sm sm:text-base space-y-1">
                            <li className="text-justify flex gap-3 flex-wrap justify-center">
                                <strong className=" inline-block">
                                    Τράπεζα:
                                </strong>{' '}
                                <span>ΠΕΙΡΑΙΩΣ</span>
                            </li>
                            <li className="text-justify flex gap-3 flex-wrap justify-center">
                                <strong className=" inline-block">
                                    Δικαιούχος:
                                </strong>{' '}
                                <span> ΔΗΜΟΣ ΚΑΡΠΑΘΟΥ</span>
                            </li>
                            <li className="text-justify flex gap-3 flex-wrap justify-center">
                                <strong className=" inline-block">IBAN:</strong>{' '}
                                <span className="break-all">
                                    GR04 0171 1780 0061 7810 1459 620
                                </span>
                            </li>
                            <li className="text-justify flex gap-3 flex-wrap justify-center">
                                <strong className="inline-block">
                                    Αριθμός Λογαριασμού:
                                </strong>{' '}
                                <span> 6178101459620</span>
                            </li>
                        </ul>

                        <p className="mt-4 text-xs italic sm:text-sm font-medium border-t pt-2 border-gray-200">
                            *Στην αιτιολογία της κατάθεσης, παρακαλούμε
                            αναγράψτε οπωσδήποτε το ονοματεπώνυμό σας και τον
                            αριθμό της οφειλής/υπόθεσης για την ταυτοποίηση της
                            συναλλαγής.
                        </p>
                    </>
                ),
                type: 'errorPayment',
            }))

            return
        } catch (err) {
            console.error(err)
            return false
        }
    }

    const formBody = (
        <>
            <header className="font-light text-3xl text-center border-b border-primary py-6 self-stretch">
                Πληρωμή Οφειλής
            </header>

            {isMobile ? (
                <FormBodyMobile
                    handleChange={handleChange}
                    submitHandler={submitHandler}
                    termsAccepted={termsAccepted}
                    handleTerms={handleTerms}
                />
            ) : (
                <FormBodyDesktop
                    handleChange={handleChange}
                    submitHandler={submitHandler}
                    termsAccepted={termsAccepted}
                    handleTerms={handleTerms}
                />
            )}
        </>
    )

    return (
        <>
            {popup.shown && (
                <PopupMessage
                    message={popup.message}
                    type={popup.type}
                    closePopUp={() =>
                        setPopup(values => ({ ...values, shown: false }))
                    }
                    showCloseButton={true}
                />
            )}
            <Modal classes="w-1/2 self-center justify-self-center my-8">
                {formBody}
            </Modal>
        </>
    )
}

export default PaymentForm
